__turbopack_context__.v({
  "container": "HeroSection-module__i6wnFa__container",
  "headerBackground": "HeroSection-module__i6wnFa__headerBackground",
  "headerContainer": "HeroSection-module__i6wnFa__headerContainer",
  "headerImage": "HeroSection-module__i6wnFa__headerImage",
  "heading": "HeroSection-module__i6wnFa__heading",
  "heroImageInnerContainer": "HeroSection-module__i6wnFa__heroImageInnerContainer",
  "heroImageOuterContainer": "HeroSection-module__i6wnFa__heroImageOuterContainer",
  "heroVideoContainer": "HeroSection-module__i6wnFa__heroVideoContainer",
});
